module.exports = __webpack_public_path__ + "00ad88c6b2380b68ec4f767c90e0fec8.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/videos/SpeechGuardON.mp4
// module id = 399
// module chunks = 0